function initCookies() {
    silktideCookieBannerManager.updateCookieBannerConfig({
        background: {
            showBackground: true
        },
        cookieIcon: {
            position: "bottomLeft"
        },
        cookieTypes: [
            {
                id: "necessary",
                name: "Necessary",
                description: "<p>Te pliki cookie są niezbędne do prawidłowego funkcjonowania witryny i nie można ich wyłączyć. Pomagają one między innymi w logowaniu i ustawianiu preferencji prywatności.</p>",
                required: true,
                onAccept: function() {
                    // console.log('Add logic for the required Necessary here');
                }
            },
            {
                id: "analytics",
                name: "Analytics",
                description: "<p>Te pliki cookie pomagają nam ulepszać witrynę, śledząc, które strony są najpopularniejsze i w jaki sposób odwiedzający poruszają się po witrynie.</p>",
                required: false,
                onAccept: function() {
                    gtag('consent', 'update', {
                        analytics_storage: 'granted',
                    });
                    dataLayer.push({
                        'event': 'consent_accepted_analytics',
                    });
                },
                onReject: function() {
                    gtag('consent', 'update', {
                        analytics_storage: 'denied',
                    });
                }
            }
        ],
        text: {
            banner: {
                description: "<p>Na naszej stronie internetowej używamy plików cookie w celu zwiększenia komfortu użytkowania, dostarczania spersonalizowanych treści i analizowania ruchu w witrynie. <a href=\"./files./policy.pdf\" target=\"_blank\">Cookie Policy.</a></p>",
                acceptAllButtonText: "Zaakceptuj wszystkie",
                acceptAllButtonAccessibleLabel: "Zaakceptuj wszystkie cookies",
                rejectNonEssentialButtonText: "Odrzuć opcjonalne",
                rejectNonEssentialButtonAccessibleLabel: "Odrzuć opcjonalne",
                preferencesButtonText: "Preferencje",
                preferencesButtonAccessibleLabel: "Przełącz preferencje"
            },
            preferences: {
                title: "Dostosuj swoje preferencje dotyczące plików cookie",
                description: "<p>Szanujemy Twoje prawo do prywatności. Możesz nie zezwolić na niektóre rodzaje plików cookie. Twoje preferencje dotyczące plików cookie będą miały zastosowanie na całej naszej stronie internetowej.</p>",
                creditLinkText: "Pobierz ten baner za darmo",
                creditLinkAccessibleLabel: "Pobierz ten baner za darmo"
            }
        }
    });
}


if (typeof silktideCookieBannerManager !== 'undefined') {
    initCookies();
}
